import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {queryOptions, useSuspenseQuery} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'
import type {ActivityPayload} from '../../../routes/route-payload-types'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useEffectiveSelection} from './use-effective-selection'

export function useSuspenseActivityPageData() {
  const {data, ...rest} = useSuspenseQuery(useActivityQueryOptions())
  return {...data, ...rest}
}

function useActivityQueryOptions() {
  const {effectiveSelection, lastActivityTimestamp} = useEffectiveSelection()
  const queryKey = [PageData.activity, effectiveSelection?.timestamp, lastActivityTimestamp] as const

  const searchParams = new URLSearchParams()
  searchParams.append('since', effectiveSelection?.timestamp ?? '')
  const apiURL = usePageDataUrl(PageData.activity, searchParams.toString())

  return queryOptions({
    queryKey,
    // the since query param is required, so we can't enable the query if it's not set
    enabled: !!effectiveSelection,
    queryFn: () => fetchActivityPageData(apiURL),
    staleTime: Infinity,
  })
}

async function fetchActivityPageData(url: string): Promise<ActivityPayload> {
  const response = await reactFetchJSON(url)
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  return response.json()
}
